import { render, staticRenderFns } from "./ComplimentCards.vue?vue&type=template&id=b5f32e18"
import script from "./ComplimentCards.vue?vue&type=script&lang=js"
export * from "./ComplimentCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports